var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "EditIcon_svg__a",
  width: 14,
  height: 14,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h14v14H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#EditIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.168 12.25v-.963a.6.6 0 0 1 .175-.423l3.048-3.033a.8.8 0 0 1 .292-.19 1 1 0 0 1 .32-.058.88.88 0 0 1 .628.263l.54.54q.116.13.182.29a.8.8 0 0 1 .065.322q0 .16-.058.328a.8.8 0 0 1-.19.299l-3.033 3.033a.58.58 0 0 1-.423.175h-.962a.56.56 0 0 1-.416-.168.56.56 0 0 1-.168-.415m.875-.292h.554l1.765-1.779-.54-.54-1.779 1.765zm-5.541.875q-.482 0-.824-.342a1.12 1.12 0 0 1-.343-.825V2.333q0-.48.343-.824.342-.342.824-.342h4.185a1.15 1.15 0 0 1 .817.335l2.829 2.83q.16.16.248.371.087.211.087.445v.831a.56.56 0 0 1-.167.416.56.56 0 0 1-.416.167.56.56 0 0 1-.416-.167.56.56 0 0 1-.167-.416v-.73H8.168a.56.56 0 0 1-.415-.167.56.56 0 0 1-.168-.415V2.333H3.502v9.334h2.916q.249 0 .416.167.168.168.168.416a.56.56 0 0 1-.168.415.56.56 0 0 1-.416.168zM11.1 9.902l-.277-.263.539.54z"
}))));
export default SvgEditIcon;